import { uuid } from '../../../CodesThatsGottaGoSomewhereElse';
import { Component, ObjectManager } from '../../../concepts/objects';
import { ActiveObject, resolve } from '../../Container';
import { Tag } from './Tag';

const colorKey = (tag: Tag) => {
    const name = tag.name.toUpperCase();
    const value = tag.value.toUpperCase();
    if (name === value) {
        return name;
    }
    return `${name}/${value}`;
};

export class TaggingMechanics extends ActiveObject {

    @resolve(ObjectManager) private objects!: ObjectManager;

    public start(): void {
        this.burden(
            this.objects.on('updated', this.touchTagParentOnUpdate),
            this.objects.createTrigger('Tag.PropagateLinkedProps')
                .for(Tag).onChangesTo('symbol', 'color').do(this.propagateLinkedProps),
        );
    }

    private touchTagParentOnUpdate = (updated: Component[]) => {
        const list = [] as Component[];
        for (const c of updated) {
            if (c.is(Tag) && !!c.parent) {
                list.push(c.parent);
            }
        }
        if (list.length > 0) {
            this.scheduler.timeout(uuid(), 0, () => {
                this.objects.touch(list);
            });
        }
    };

    private propagateLinkedProps = (tags: Tag[]) => {

        // Build list of things to set
        const colors = new Map(tags.map(x => [colorKey(x), x.color]));
        const symbols = new Map(tags.map(x => [x.name, x.symbol]));

        // Apply
        this.objects.update(() => {
            const allTags = this.objects.getAll(Tag);
            for (const t of allTags) {
                const ck = colorKey(t);
                if (colors.has(ck) && t.color !== colors.get(ck)) {
                    t.color = colors.get(ck);
                }
                const symbolKey = t.name;
                if (symbols.has(symbolKey) && t.symbol !== symbols.get(symbolKey)) {
                    t.symbol = symbols.get(symbolKey);
                }
            }
        });
    };
}
